import { NavUser } from '../nav-user';
import type { AvatarDropdownItem } from '@/features/header/components/avatar-dropdown';
import { SidebarFooter, SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';
import { Icon } from '@/components';
import { useTranslation } from 'react-i18next';

export type MainSidebarFooterProps = {
  readonly userMenuOptions: AvatarDropdownItem[];
  readonly className?: string;
  readonly showSupportLinks?: boolean;
  readonly onSupportClick?: () => void;
  readonly onFeedbackClick?: () => void;
};

export function MainSidebarFooter({
  userMenuOptions,
  className,
  showSupportLinks = true,
  onSupportClick,
  onFeedbackClick,
}: MainSidebarFooterProps) {
  const { t } = useTranslation(['sidebar']);

  return (
    <SidebarFooter className={className}>
      {showSupportLinks ? (
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              className="hover:cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                onSupportClick?.();
              }}
              tooltip={t('Support')}
            >
              <Icon name="headphones" />
              <span>{t('Support')}</span>
            </SidebarMenuButton>
          </SidebarMenuItem>

          <SidebarMenuItem>
            <SidebarMenuButton
              className="hover:cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                onFeedbackClick?.();
              }}
              tooltip={t('Feedback')}
            >
              <Icon name="message-square" />
              <span>{t('Feedback')}</span>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      ) : null}

      <NavUser options={userMenuOptions} />
    </SidebarFooter>
  );
}
